<cx-global-message aria-atomic="true" aria-live="assertive" style="width: auto">
</cx-global-message>
<cx-spinner class="overlay" *ngIf="isSpinnerLoading"></cx-spinner>
<div class="user-management">
  <span class="user-management__header">{{ "usermanagement.user" | cxTranslate }}</span>
  <div [ngClass]="{'two-div':isAddUserFlag}">
    <div class="user-management__content" [ngClass]="{'w-50': isAddUserFlag , 'w-100':!isAddUserFlag}">
      <div class="user-management__content__header">
        <span>{{
          "usermanagement.allUser"
          | cxTranslate: { count: userData?.length }
          }}</span>
       
          <span  (click)="addUserBtnOnClick()">
            <i class="fa fa-plus-circle" aria-hidden="true"></i>
          </span>
      </div>

      <div class="user-management__content__list">
        <table class="table table-borderless" aria-describedby="usermanagement">
          <thead>
            <tr>
              <th scope="col" colspan="2" class="name-icon">{{ "usermanagement.name" | cxTranslate
                }}<i class="fa fa-sort" aria-hidden="true"></i>
              </th>
              <th scope="col" colspan="1">{{ "usermanagement.status" | cxTranslate }}</th>
              <th scope="col" colspan="2" [ngClass]="{'hidden_row': isAddUserFlag }">{{
                "usermanagement.email" | cxTranslate }}</th>
              <th scope="col" colspan="1" [ngClass]="{'hidden_row': isAddUserFlag}">{{
                "usermanagement.roles" | cxTranslate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let user of userData">
              <td colspan="2" (click)="openUserDetails(user)">{{user?.name}}</td>
              <td colspan="1">{{user?.active ? 'Active' :'Not Active'}}</td>
              <td colspan="2" [ngClass]="{'hidden_row': isAddUserFlag}">
                {{user?.uid}}</td>
              <td colspan="1" [ngClass]="{'hidden_row': isAddUserFlag }"><span>{{getRoleType(user?.roles)}}
                </span></td>
              <td colspan="1" (click)="openUserDetails(user)" class="text-center">
                <i class="fa fa-caret-right" aria-hidden="true"></i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="user-management__add-update-user"
      [ngClass]="{'hidden_row': !isAddUserFlag, 'add-user-view-user-height':isExistingUser,'edit-user-height':isExistingUserWithValue}">
      <form [formGroup]="form" class="d-flex flex-column">

        <div class="user-management__add-update-user__header">
          <span>{{isExistingUserWithValue || isExistingUser? 'User Details' : 'Add a new user'}}</span>
          <img (click)="onCloseAddUser()" src="../../../../assets/images/close_btn.png" alt="">
        </div>
        <div class="user-management__add-update-user__form-content">
          <label class="mt-4 form-label" [ngClass]="{'edit-user-label': isExistingUser || isExistingUserWithValue}">
            <span>{{ "usermanagement.salutation" | cxTranslate }}<span
                *ngIf="!isExistingUser && !isExistingUserWithValue">*</span></span>
            <select class="form-control salutation" formControlName="salutation"
              *ngIf="!isExistingUser && !isExistingUserWithValue">
              <option value="Mr."> {{ "usermanagement.mr" | cxTranslate }}</option>
              <option value="Ms."> {{ "usermanagement.ms" | cxTranslate }}</option>
            </select>
            <cx-form-errors [control]="form.get('salutation')" *ngIf="!isExistingUser"></cx-form-errors>
            <span *ngIf="isExistingUser || isExistingUserWithValue">{{userDetails?.title}}</span>
          </label>
          <label class="mt-4 form-label" [ngClass]="{'edit-user-label': isExistingUser || isExistingUserWithValue}">
            <span>{{ "usermanagement.firstName" | cxTranslate }}<span
                *ngIf="!isExistingUser && !isExistingUserWithValue">*</span></span>
            <input required="true" type="text" class="form-control mt-2" pattern="^[a-zA-Z][a-zA-Z]*"
              formControlName="first_name" *ngIf="!isExistingUser && !isExistingUserWithValue" />
            <cx-form-errors [control]="form.get('first_name')" *ngIf="!isExistingUser"></cx-form-errors>
            <span *ngIf="isExistingUser || isExistingUserWithValue">{{userDetails?.firstName}}</span>
          </label>
          <label class="mt-4 form-label" [ngClass]="{'edit-user-label': isExistingUser || isExistingUserWithValue}">
            <span>{{ "usermanagement.lastName" | cxTranslate }}<span
                *ngIf="!isExistingUser && !isExistingUserWithValue">*</span></span>
            <input required="true" type="text" class="form-control mt-2" formControlName="last_name"
              *ngIf="!isExistingUser && !isExistingUserWithValue" pattern="^[a-zA-Z][a-zA-Z]*" />
            <cx-form-errors [control]="form.get('last_name')" *ngIf="!isExistingUser"></cx-form-errors>
            <span *ngIf="isExistingUser || isExistingUserWithValue">{{userDetails?.lastName}}</span>
          </label>
          <label class="mt-4 form-label" [ngClass]="{'edit-user-label': isExistingUser || isExistingUserWithValue}">
            <span>{{ "usermanagement.email" | cxTranslate }}<span
                *ngIf="!isExistingUser && !isExistingUserWithValue">*</span></span>
            <input required="true" type="text" class="form-control mt-2 "
              [ngClass]="{'user-email-invalid': isUserExist}" formControlName="email"
              *ngIf="!isExistingUser && !isExistingUserWithValue" />
            <cx-form-errors [control]="form.get('email')" *ngIf="!isExistingUser"></cx-form-errors>
            <span class="user-email-invalid__text" *ngIf="isUserExist">{{ "usermanagement.error.userExist" | cxTranslate
              }}</span>
            <span *ngIf="isExistingUser || isExistingUserWithValue">{{userDetails?.uid}}</span>
          </label>
          <label class="mt-4 form-label" [ngClass]="{'edit-user-label': isExistingUser}">
            <span>{{ "usermanagement.roleAccess" | cxTranslate }}<span
                *ngIf="!isExistingUser && !isExistingUserWithValue">*</span></span>
            <div *ngIf="!isExistingUser" class="rolerow">

              <label class="checkbox-label">
                <input type="radio" value="Admin" formControlName="role">
                <span>{{ "usermanagement.admin" | cxTranslate }}</span>
              </label>
              <label class="checkbox-label">
                <input type="radio" value="Buyer" formControlName="role">
                <span>{{ "usermanagement.buyer" | cxTranslate }}</span>
              </label>
              <label class="checkbox-label">
                <input type="radio" value="Claims" formControlName="role">
                <span>{{ "usermanagement.raiseClaims" | cxTranslate }}</span>
              </label>

            </div>
            <span *ngIf="isExistingUser">{{getRoleType(userDetails?.roles)}}</span>
          </label>
        </div>
        <span class="succes-msg" *ngIf="isUserSuccess && !isExistingUserWithValue"> {{ "usermanagement.createSuccess" |
          cxTranslate
          }}
        </span>
        <span class="succes-msg" *ngIf="isUserSuccess && isExistingUserWithValue"> {{ "usermanagement.updateSuccess" |
          cxTranslate}}
        </span>
        <div class="user-management__add-update-user__add-update-btn">
          <span *ngIf="isExistingUser" style="cursor: pointer;" (click)="editUser()">
            {{ "usermanagement.editUser" | cxTranslate }}</span>
          <cx-progress-button [class]="'btn btn-block'" tabindex="-1" *ngIf="!isExistingUser"
            (click)="onCloseAddUser()">
            CANCEL
          </cx-progress-button>
          <cx-progress-button [class]="'btn btn-block'" tabindex="-1" *ngIf="!isExistingUser"
            (click)="addOrUpdateUser()" [disabled]="isInValidFormData">
            {{isExistingUserWithValue? 'UPDATE USER':'ADD USER'}}
          </cx-progress-button>
        </div>



      </form>
    </div>
  </div>

</div>